var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-block spacex-12"},[_c('InfoIcon',{staticClass:"icon-20px orange-icon"}),_c('span',{staticClass:"info-block__text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }